import { createContext, useContext } from "react";

/**
 * Lets deep pages (e.g. patient chat thread) hide fixed chrome so content can use the full viewport.
 */
export const PatientShellChromeContext = createContext(null);

export function usePatientShellChrome() {
  const ctx = useContext(PatientShellChromeContext);
  return (
    ctx ?? {
      bottomNavHidden: false,
      setBottomNavHidden: () => {},
      appBarHidden: false,
      setAppBarHidden: () => {},
      chromeScrollHidden: false,
      appBarScrollCollapsed: false,
    }
  );
}
